"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class AxiosInstance {
    static create(hostType = 'default', widthHeaders = false) {
        const config = {
            baseURL: window.AppearMe.appConfigs.url,
            timeout: 60000, // default timeout of 60 seconds
            //withCredentials: true,
        };
        const axiosInstance = axios_1.default.create(config);
        // before the request is sent to the server, add jwt to the Authorization header
        axiosInstance.interceptors.request.use(config => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['appearme-token'] = `${token.replace('%20', ' ')}`;
            }
            return config;
        });
        // whenever a response is received from the node layer
        axiosInstance.interceptors.response.use(response => {
            if (widthHeaders) {
                return {
                    data: response.data,
                    headers: response.headers
                };
            }
            return response.data;
        }, error => {
            //console.warn('request error', error);
            return Promise.reject(error.response ? {
                code: error.response.status,
                data: error.response.data
            } : { message: error });
        });
        return axiosInstance;
    }
}
exports.default = AxiosInstance;
